module.exports = __webpack_public_path__ + "static/media/diary_song_bg.fc865600.png";